module.exports = __webpack_public_path__ + "img/ico-msg-send-red.8aecb009.svg";